import React from "react";
import "./ToggleButton.scss";
import { HiLockClosed, HiLockOpen } from "react-icons/hi";
import { Tooltip } from "react-tooltip";

interface ToggleButtonProps {
  setTrue: (value: boolean) => void;
  isTrue: boolean;
  trueValue: string;
  falseValue: string;
  type: string;
}

const ToggleButton: React.FC<ToggleButtonProps> = ({
  setTrue,
  isTrue,
  trueValue,
  falseValue,
  type,
}) => {
  return (
    <div className="ToggleButton">
      <p
        className="title"
        dangerouslySetInnerHTML={{
          __html: isTrue ? trueValue : falseValue,
        }}
      ></p>
      <label className="toggle">
        <input
          type="checkbox"
          className="toggle__input"
          defaultChecked={isTrue}
          onClick={(e) => {
            setTrue((e.target as HTMLInputElement).checked);
          }}
        />
        <span className="toggle-track" id="checkbox">
          <span
            className="toggle-indicator"
            data-tooltip-id="encryption-tooltip"
            data-tooltip-content={
              type === "encrypted" && !isTrue ? "Upload Encrypted Files" : ""
            }
          >
            <span className="notCheckMark">
              {type === "encrypted" && <HiLockOpen />}
            </span>
            <span className="checkMark">
              {type === "encrypted" && (
                <HiLockClosed style={{ fill: "white" }} />
              )}
            </span>
          </span>
        </span>
      </label>
      <Tooltip id="encryption-tooltip" />
    </div>
  );
};

export default ToggleButton;
